import { useTranslation } from 'react-i18next';
import { useAppSelector } from '$hooks/use-app-selector.hook';
import RemoteSVG from '$components/RemoteSVG/RemoteSVG';
import Home from '../../Home/Home';
import ForgotPasswordForm from '../../ForgotPasswordForm/ForgotPasswordForm';
import classes from './ForgotPasswordScreen.module.css';

const ForgotPasswordScreen = () => {
  const [t] = useTranslation('global');
  const { logoUrl } = useAppSelector((state) => state.brand);
  return (
    <Home>
      <section className={classes.container}>
        <h1 className={classes.header}>{t('forgotPass.title')} </h1>
        <div className={classes.divider} />
        <p className={classes.subHeader}>{t('forgotPass.instructions')}</p>
        <div className={classes.card}>
          {logoUrl && (
            <RemoteSVG svgProps={{ className: 'w-52' }} url={logoUrl} />
          )}
          <ForgotPasswordForm />
        </div>
      </section>
    </Home>
  );
};

export default ForgotPasswordScreen;
